import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type MomentCustomFieldResourceV3 = OpalApiComponent<'V3', 'moment_custom_field'>

export const momentCustomFieldFactory: Factory<MomentCustomFieldResourceV3> =
  Factory.define<MomentCustomFieldResourceV3>(
    () =>
      ({
        id: uuidV4(),
        type: 'moment_custom_field',
        attributes: {
          text_value: null,
        },
        relationships: {
          moment: {
            data: {
              id: uuidV4(),
              type: 'moment',
            },
          },
          custom_field: {
            data: {
              id: uuidV4(),
              type: 'custom_field',
            },
          },
        },
      }) satisfies MomentCustomFieldResourceV3
  )
